import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import {
  DynamicFormConfig,
  FieldConfig,
} from 'src/app/shared/components/dynamic-form/dynamic-form-config.interface';
import { Title } from 'src/app/shared/components/title/title.component';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IBundle } from 'src/app/core/interfaces/shared/bundle/IBundle';
import { DynamicFormService } from 'src/app/shared/components/dynamic-form/dynamic-form.service';

export enum NewProductButtonsEnum {
  YES = 'Sí',
  NO = 'No',
}
@Injectable()
export class JsonConfiguration {
  titleData: Title;
  headerConfiguration: HeaderConfiguration;
  dynamicForm: DynamicFormConfig;
  
  
  status: IBundle;
  selectProduct: any;
  translateKey: string = 'calculator';
  partnerCode: string;

  /**
   * Set initial configuration related data and i18n
   */
  constructor(
    private translateService: TranslateService,
    private dynamicFormService: DynamicFormService,
    ) {
    this.setTitleData();
    this.setHeaderConfiguration();
    //this.setDynamicForm();
  }

  /**
   * Set title related data with i18n
   */
  private setTitleData(): void {
    this.titleData = {
      title: '',
    };

    this.translateService.get('calculator.title').subscribe( res => {
      this.titleData.title = res
    })
  }

  /**
   * Set header related data with i18n
   */
  private setHeaderConfiguration(): void {
    this.headerConfiguration = {
      layoutAlign: 'start start',
      sections: [
        {
          partner:true,
          menu:true,       
        }
      ],
    };
  }

  /**
   * Set dynamicForm configuration
   */
   setDynamicForm(): void {
    const productField = this.generateProductField();
    
    this.dynamicForm = {
      fxLayout: 'row wrap',
      fxLayoutGap: '1rem',
      fxLayoutAlign: 'start start',
      fields: [productField]
    };
  }

  /**
   * Generate sex field with validations and label
   * @returns The field generated
   */
  generateProductField(): FieldConfig {
    const inputName = "typeOfProduct";
    let label;
    this.translateService.get(this.translateKey + `.input.${inputName}.label`).subscribe( res => {label = res})
    const productValidation = this.dynamicFormService.generateRequiredValidation(this.translateKey);

    // this.setProductOptions();
    this.getProducts();

    return this.dynamicFormService.generateField(inputName, label, "autocomplete", null, null, "100%", [productValidation], { select: this.selectProduct });
  }

  getProducts() {
    this.partnerCode = '43106';
    this.selectProduct = {

      options: [],
      isMultiple: false
    }
  }

  
}
